export default __webpack_public_path__ + "static/media/Metropolis-Bold.2e45979b.woff2";